/**
 * TOP
 */
 'use strict';
 import '@/_constant/global';
 import pCommon from '@/_page/pCommon';
  
  document.addEventListener('DOMContentLoaded', () => {
    gSTRG.mods['page'] = new pCommon();
  }, false);
  
  window.addEventListener('load', () => {
    gSTRG.mods['page'].start();
  }, false);
  
  window.addEventListener('unload', () => {}, false);
 
 Number.isNaN = Number.isNaN || function(any) {
   return typeof any === 'number' && isNaN(any);
 };
 
 Number.prototype.map = function(in_min, in_max, out_min, out_max) {
   return ((this - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
 };
 